export enum BINRule {
    None,
    AllowByCriteria,
    BlockByCriteria,
    BlockForAll,
    AllowForAll,
}